import { Component } from '@angular/core';

@Component({
  selector: 'cloud-message-only-qes',
  templateUrl: './message-only-qes.component.html',
  styleUrls: ['./message-only-qes.component.scss']
})
export class MessageOnlyQESComponent {

}
